export type PageAssistantTemplate = {
  label: string;
  title: string;
  description: string;
  prompt: string;
};

type PageAssistantContent = {
  templates: PageAssistantTemplate[];
};

const content = (templates: PageAssistantTemplate[]): PageAssistantContent => ({
  templates,
});

const pageAssistantContent: Record<string, PageAssistantContent> = {
  "/": content([
    {
      label: "首页导览",
      title: "从增长路径开始",
      description:
        "这里概览品牌增长与产品出海两条路径，以及品牌、网站、内容、搜索和运营如何协同。",
      prompt: "帮我判断更适合品牌增长还是产品出海",
    },
    {
      label: "首页导览",
      title: "建立可积累的增长资产",
      description:
        "GrowDeep 关注的不只是一次项目交付，而是让官网、内容与线索入口持续发挥作用。",
      prompt: "我想了解增长资产如何落地",
    },
  ]),
  "/about": content([
    {
      label: "关于 GrowDeep",
      title: "AI 提升效率，团队负责判断",
      description:
        "我们用 AI 工具加速执行，但策略、质量和项目节奏始终由增长团队负责。",
      prompt: "你们与普通服务商有什么区别",
    },
    {
      label: "关于 GrowDeep",
      title: "围绕真实业务问题推进",
      description:
        "从目标、客户和现状出发，把品牌表达、网站阵地和获客动作连接起来。",
      prompt: "想了解你们的合作方法",
    },
  ]),
  "/services": content([
    {
      label: "核心服务",
      title: "六项能力可以组合推进",
      description:
        "品牌定位、网站、内容、SEO/GEO、市场增长和线索运营，按企业阶段组织实施。",
      prompt: "帮我梳理适合的服务组合",
    },
    {
      label: "核心服务",
      title: "先解决当前增长短板",
      description: "服务以业务优先级为起点，不把所有动作打包成一套固定方案。",
      prompt: "我想先判断当前最需要解决的问题",
    },
  ]),
  "/cases": content([
    {
      label: "客户案例",
      title: "查看增长资产如何落地",
      description:
        "案例围绕真实业务问题、交付资产和持续运营状态展开，具体数据在客户授权后公开。",
      prompt: "我想了解类似企业如何推进增长",
    },
    {
      label: "客户案例",
      title: "从业务场景看结果",
      description:
        "这里重点呈现品牌表达、官网阵地、内容资产和咨询路径如何共同解决问题。",
      prompt: "案例中通常会交付哪些内容",
    },
  ]),
  "/insights": content([
    {
      label: "增长洞察",
      title: "把方法转化为可执行动作",
      description:
        "围绕品牌、内容、搜索和线索运营，沉淀适合企业长期使用的增长方法。",
      prompt: "我想了解 SEO/GEO 的推进思路",
    },
    {
      label: "增长洞察",
      title: "从问题到优先级",
      description: "通过行业观察和实践方法，帮助团队判断下一步应该先做什么。",
      prompt: "帮我梳理当前增长优先级",
    },
  ]),
  "/pricing": content([
    {
      label: "套餐价格",
      title: "按当前起点选择服务",
      description:
        "从初步诊断到定制版，套餐对应不同的业务基础、协作深度和增长目标。",
      prompt: "帮我对比各套餐适合的情况",
    },
    {
      label: "套餐价格",
      title: "先确认范围，再确认报价",
      description:
        "基础服务费、第三方费用和出海业务抽成分别计算，正式范围以报价单和合同为准。",
      prompt: "我想了解服务收费和周期",
    },
  ]),
  "/contact": content([
    {
      label: "联系顾问",
      title: "从一次增长诊断开始",
      description:
        "先说明业务现状、目标市场和当前问题，再共同判断适合的推进路径。",
      prompt: "我想预约一次增长诊断",
    },
    {
      label: "联系顾问",
      title: "让问题被准确理解",
      description:
        "品牌表达、官网、内容、搜索或海外获客，都可以从现状梳理开始。",
      prompt: "我想描述一下目前遇到的问题",
    },
  ]),
  "/privacy": content([
    {
      label: "隐私政策",
      title: "咨询信息仅用于服务沟通",
      description:
        "您主动提交的企业和业务信息用于回复咨询、项目评估及必要协作，不用于无关用途。",
      prompt: "我想了解咨询信息如何被使用",
    },
    {
      label: "隐私政策",
      title: "尊重每一次业务沟通",
      description: "企业信息会按服务沟通和项目协作的需要处理，并受到相应保护。",
      prompt: "我有关于信息保护的问题",
    },
  ]),
  "/terms": content([
    {
      label: "服务条款",
      title: "以可验收的动作持续推进",
      description:
        "项目会明确目标、范围、周期和交付物；外部平台与市场变化不构成固定结果承诺。",
      prompt: "我想了解服务边界和合作方式",
    },
    {
      label: "服务条款",
      title: "增长需要双方共同投入",
      description:
        "GrowDeep 负责专业交付与持续优化，企业需要提供真实资料、反馈和关键节点确认。",
      prompt: "合作过程中企业需要配合什么",
    },
  ]),
  "/workspace": content([
    {
      label: "增长工作台",
      title: "把动作和反馈放在同一视图",
      description: "围绕页面、内容、搜索、线索和复盘建立可持续追踪的增长节奏。",
      prompt: "我想了解增长工作台如何使用",
    },
    {
      label: "增长工作台",
      title: "用数据安排下一步",
      description: "将网站访问、客户线索和一线反馈转化为下一阶段的优化优先级。",
      prompt: "怎样建立增长数据复盘机制",
    },
  ]),
  "/solutions": content([
    {
      label: "增长解决方案",
      title: "选择适合业务阶段的路径",
      description:
        "国内品牌增长、产品出海、官网增长与制造业增长，都从客户决策与业务目标开始。",
      prompt: "帮我判断适合哪条增长路径",
    },
    {
      label: "增长解决方案",
      title: "把分散动作接成完整链路",
      description:
        "方案将品牌表达、官网、内容、搜索和咨询入口组织为可持续运营的系统。",
      prompt: "我想了解解决方案如何组合服务",
    },
  ]),
};

const serviceContent: Record<string, PageAssistantContent> = {
  "brand-positioning": content([
    {
      label: "品牌定位服务",
      title: "先让客户理解你的价值",
      description:
        "梳理目标客户、核心价值和产品表达，为官网、内容和销售沟通建立统一口径。",
      prompt: "我想了解品牌定位服务如何推进",
    },
    {
      label: "品牌定位服务",
      title: "把优势转化为客户语言",
      description:
        "从企业自身视角转向客户决策视角，明确值得被记住的品牌和产品信息。",
      prompt: "我们现有品牌表达有哪些常见问题",
    },
  ]),
  "website-development": content([
    {
      label: "官网与独立站",
      title: "让网站承担增长任务",
      description:
        "官网或独立站不仅展示信息，也应服务于理解产品、建立信任和发起咨询。",
      prompt: "我想了解官网或独立站建设",
    },
    {
      label: "官网与独立站",
      title: "按客户决策路径重构页面",
      description:
        "将产品、案例、内容和咨询入口组织得更清晰，降低客户获取信息的成本。",
      prompt: "现有网站适合从哪里开始优化",
    },
  ]),
  "content-marketing": content([
    {
      label: "内容营销",
      title: "让专业内容持续积累",
      description:
        "围绕客户问题和搜索意图建设服务页、案例与文章，为长期信任和曝光打下基础。",
      prompt: "我想了解内容营销如何规划",
    },
    {
      label: "内容营销",
      title: "内容服务于理解与决策",
      description: "复杂产品和长决策周期更需要用内容解释价值、场景和选择依据。",
      prompt: "我们的内容体系该从什么主题开始",
    },
  ]),
  "seo-geo": content([
    {
      label: "SEO / GEO",
      title: "同时布局搜索与 AI 可见性",
      description:
        "通过技术配置、内容主题和结构化数据，提升在 Google、传统搜索与 AI 回答中的曝光。",
      prompt: "我想了解 SEO 和 GEO 的区别",
    },
    {
      label: "SEO / GEO",
      title: "让有价值的内容被找到",
      description:
        "从关键词、页面意图到站点结构，逐步改善收录、理解和自然搜索表现。",
      prompt: "如何评估网站的 SEO/GEO 基础",
    },
  ]),
  "market-growth": content([
    {
      label: "市场增长",
      title: "先明确目标，再组织动作",
      description:
        "研究客户、市场和竞争环境，把品牌、内容、渠道和销售协作转为清晰优先级。",
      prompt: "我想梳理市场增长策略",
    },
    {
      label: "市场增长",
      title: "避免分散投入",
      description: "用统一的目标、重点客户和数据反馈，协调不同渠道与市场动作。",
      prompt: "我们的市场动作比较分散，怎么开始整理",
    },
  ]),
  "lead-operations": content([
    {
      label: "线索运营",
      title: "让访问变成可跟进线索",
      description:
        "统一咨询入口、记录来源、优化承接路径，再通过反馈持续改善网站和内容。",
      prompt: "我想改善网站的询盘承接",
    },
    {
      label: "线索运营",
      title: "把数据接回业务决策",
      description:
        "通过访问、咨询和销售反馈判断哪些内容与渠道真正带来有效客户。",
      prompt: "如何建立线索来源追踪和复盘",
    },
  ]),
};

const solutionContent: Record<string, PageAssistantContent> = {
  "domestic-brand-growth": content([
    {
      label: "国内品牌增长",
      title: "建立自主的品牌与获客基础",
      description:
        "围绕品牌定位、官网、内容、SEO/GEO 与咨询入口，提升国内市场的长期认知。",
      prompt: "我想了解国内品牌增长如何开展",
    },
    {
      label: "国内品牌增长",
      title: "从产品优势到市场认知",
      description:
        "适合产品具备竞争力，但品牌表达、内容和自主获客渠道仍然薄弱的企业。",
      prompt: "我们的品牌增长短板该怎么判断",
    },
  ]),
  "product-global-expansion": content([
    {
      label: "产品出海增长",
      title: "把好产品带向全球客户",
      description:
        "建设海外品牌表达、独立站、Google SEO/GEO 内容和可追踪的询盘路径。",
      prompt: "我想了解产品出海增长方案",
    },
    {
      label: "产品出海增长",
      title: "先建立自己的海外阵地",
      description:
        "适合希望降低平台依赖、提升海外客户理解与询盘效率的制造和外贸企业。",
      prompt: "我们出海应该先做独立站还是搜索",
    },
  ]),
  "corporate-website-growth": content([
    {
      label: "官网增长",
      title: "让官网成为增长阵地",
      description:
        "以信息架构、产品表达、内容系统和数据监测改善客户理解、信任和咨询效率。",
      prompt: "我想评估现有官网的问题",
    },
    {
      label: "官网增长",
      title: "从展示页升级为客户入口",
      description: "适合网站结构陈旧、内容难维护或咨询路径不清晰的团队。",
      prompt: "官网改版时应该优先考虑什么",
    },
  ]),
  "global-website-growth": content([
    {
      label: "海外独立站增长",
      title: "把海外客户路径接起来",
      description:
        "连接多语言内容、产品信任证明、Google 搜索与询盘入口，服务不同国家市场。",
      prompt: "我想了解海外独立站增长",
    },
    {
      label: "海外独立站增长",
      title: "建立长期的海外客户渠道",
      description: "适合已有出口业务，但品牌、内容或自然搜索基础不足的团队。",
      prompt: "已有独立站，下一步该怎么优化",
    },
  ]),
  "manufacturing-growth": content([
    {
      label: "制造业增长",
      title: "把制造优势变成市场表达",
      description:
        "将产品、工艺、供应链和应用场景沉淀为官网、内容、搜索和询盘资产。",
      prompt: "制造企业如何做品牌和出海增长",
    },
    {
      label: "制造业增长",
      title: "让复杂产品更容易被理解",
      description:
        "适合具备产品和供应链优势，但线上表达不够专业、客户决策路径较长的企业。",
      prompt: "工业产品应该怎样规划官网和内容",
    },
  ]),
};

const fallback = content([
  {
    label: "AI顾问",
    title: "从真实业务问题开始",
    description:
      "围绕品牌、网站、内容、搜索和线索运营，找到更适合当前阶段的增长路径。",
    prompt: "我想咨询企业增长问题",
  },
  {
    label: "AI顾问",
    title: "让每一步增长更清晰",
    description: "先判断现状和优先级，再组织可持续执行的品牌与获客动作。",
    prompt: "帮我梳理当前增长优先级",
  },
]);

export function getPageAssistantContent(pathname: string) {
  if (pathname.startsWith("/services/"))
    return serviceContent[pathname.split("/")[2]] ?? fallback;
  if (pathname.startsWith("/solutions/"))
    return solutionContent[pathname.split("/")[2]] ?? fallback;
  return pageAssistantContent[pathname] ?? fallback;
}
